import { render, staticRenderFns } from "./AppendixTransfer.vue?vue&type=template&id=41b3a98e&scoped=true"
import script from "./AppendixTransfer.vue?vue&type=script&lang=js"
export * from "./AppendixTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b3a98e",
  null
  
)

export default component.exports